import { db } from './config';
// ИЗМЕНЕНИЕ: Нам, блять, больше не нужен 'storage' и 'getDownloadURL' в этом файле
import { collection, getDocs, query, where, orderBy } from 'firebase/firestore'; 

/**
 * Получает данные слайдера.
 * Ожидает, что в поле 'image' каждого документа уже лежит ГОТОВАЯ публичная ссылка на картинку.
 * ЭТО, СУКА, БЫСТРО.
 */
export const getSliderData = async () => {
  try {
    const sliderCollectionRef = collection(db, 'slider');
    
    // Запрос остается таким же умным: берем только активные и сортируем по порядку
    const q = query(
      sliderCollectionRef,
      where('isActive', '==', true),
      orderBy('order', 'asc')
    );

    // Отправляем запрос getDocs для слайдера
    const snapshot = await getDocs(q);
    
    if (snapshot.empty) {
      // Активные слайды не найдены в Firestore
      return []; // Возвращаем пустой массив, если ничего нет
    }
    
    // Просто, блять, преобразуем документы в массив. Никаких дополнительных запросов за URL.
    const sliderData = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
    }));
    
    // Данные слайдера получены
    return sliderData;

  } catch (error) {
    // Пробрасываем ошибку дальше, чтобы компонент, который вызвал функцию, знал о проблеме
    throw error;
  }
};

/*
*
* ФУНКЦИЮ getSliderImageUrl МЫ, БЛЯТЬ, УДАЛИЛИ НАХУЙ.
* ОНА БЫЛА ИСТОЧНИКОМ ВСЕХ НАШИХ ПРОБЛЕМ.
* ПОКОЙСЯ С МИРОМ, СУКА.
*
*/